import { TYPES } from "./finance_reseller.type";
import { getDocs, query, where } from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const app = getApp();
const auth = getAuth(app);

// ========= firebase function =========//

//snap all provider

export const getFinanceResellerByDate =
  ({ from, to }, callback) =>
  (dispatch) => {
    const start = from?.startOf("days")?.toDate();
    const end = to?.endOf("days")?.toDate();
    console.log({ start, end });
    const uid = auth?.currentUser?.uid;
    setFinanceResellerAllSuccess(dispatch, null);
    const cRef = getRefs().reseller;
    const c0 = where("owner", "==", uid);
    const c1 = where("database", "==", "bailiff");
    const c2 = where("collection", "==", "job");
    const c3 = where("source", "==", "reseller");
    const c4 = where("setAt", ">=", start);
    const c5 = where("setAt", "<=", end);
    const qRef = query(cRef, c0, c1, c2, c3, c4, c5);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        console.log("snap dates:" + JSON.stringify(data));
        setFinanceResellerAllSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });
  };

// ========= cloud function =========//
// ========= local function =========//
export const setFinanceResellerAll = (data, callback) => (dispatch) => {
  setFinanceResellerAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setFinanceResellerOpenAdd = (data, callback) => (dispatch) => {
  setFinanceResellerOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setFinanceResellerOpenEdit = (data, callback) => (dispatch) => {
  setFinanceResellerOpenEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setFinanceResellerSelected = (data, callback) => (dispatch) => {
  setFinanceResellerSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setFinanceResellerSearch = (data, callback) => (dispatch) => {
  setFinanceResellerSearchSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};
export const setFinanceResellerDates = (data, callback) => (dispatch) => {
  setFinanceResellerDatesSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

// ========= dispatch =========//

const setFinanceResellerAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_RESELLER_ALL,
    payload: data,
  });
};

const setFinanceResellerOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_RESELLER_OPEN_ADD,
    payload: data,
  });
};

const setFinanceResellerOpenEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_RESELLER_OPEN_EDIT,
    payload: data,
  });
};

const setFinanceResellerSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_RESELLER_SELECTED,
    payload: data,
  });
};

const setFinanceResellerSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_RESELLER_SEARCH,
    payload: data,
  });
};

const setFinanceResellerDatesSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FINANCE_RESELLER_DATES,
    payload: data,
  });
};
